import React from 'react';
import { format } from 'date-fns';
import { Status, Tooltip } from '../../../components';
import { t } from 'i18next';
import LongTextCell from './LongTextCell';

const columns = [
	{
		Header: t('identification'),
		canSort: false,
		accessor: 'identification',
	},
	{
		Header: t('dxSubType'),
		canSort: false,
		accessor: 'diagnostics[0].dxSubType',
		Cell: ({ value }: any) => {
			return value ? value : '';
		},
	},
	{
		Header: t('dxSecondary'),
		canSort: false,
		accessor: 'diagnostics[0].dxSecondary',
		Cell: ({ value }: any) => {
			return value ? value : '';
		},
	},
	{
		Header: t('relapse'),
		canSort: false,
		accessor: 'diagnostics[0].relapse',
		Cell: ({ value }: any) => {
			return value ? t('yes') : t('no');
		},
	},
	{
		Header: 'NGS',
		canSort: false,
		accessor: 'ngs',
		Cell: ({ value }: any) => {
			return <LongTextCell value={value} />;
		},
	},
	{
		Header: 'Molecular studies',
		canSort: false,
		accessor: 'molecular',
		Cell: ({ value }: any) => {
			return <LongTextCell value={value} />;
		},
	},
	{
		Header: 'Obito',
		canSort: false,
		accessor: 'deathDate',
		Cell: ({ value }: any) => {
			return value ? format(new Date(value), 'dd MMM yyyy') : '';
		},
	},
];

export default columns;
